import React from 'react'
import CellContent from './CellContent'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  offer: App.HotelOffer
  packageId: string
}

function LEHotelRoomSizeCell({ offer, packageId }: Props) {
  const pkg = offer.packages.find(p => p.id === packageId)

  if (!pkg) {
    return null
  }

  return (
    <CellContent>
      <BodyText variant="medium">{pkg.roomType.sizeSqm} m&sup2;</BodyText>
    </CellContent>
  )
}

export default LEHotelRoomSizeCell
